// extracted by mini-css-extract-plugin
export var cancelButton = "_qn-5";
export var content = "_qn-3";
export var createButton = "_qn-6";
export var drawerContainer = "_qn-0";
export var footer = "_qn-2";
export var header = "_qn-1";
export var orderFormColumn = "_qn-4";